class GetMembershipRequest {
  constructor(public readonly productId: string,
              public readonly productPrice: number,
              public readonly ticketCount: number) {
  }
}

export default GetMembershipRequest;